<template>
    <v-container>

        <v-row>
            <v-col>
                <div class="headline">Soner</div>
                <br>
                <v-btn @click="showNewZoneDialog = true" :disabled="this.$store.getters.rights > 0" color="success">
                    <v-icon left>mdi-plus-circle-outline</v-icon>
                    Ny Sone
                </v-btn>

                <v-row>
                    <v-col cols="12" lg="8">
                        <v-data-table :headers="zoneHeaders" :items="zones" :loading="zonesLoading" hide-default-footer :items-per-page="-1" sort-by="name" :mobile-breakpoint="0">
                            <template v-slot:item={item}>
                                <tr @click="openEditZone(item)" style="cursor:pointer; white-space: nowrap">
                                    <td>{{item.name}}</td>
                                    <td>
                                        <v-chip pill>
                                            <v-avatar :class="colors.find(c => c.color.includes(item.color)).color" left></v-avatar>
                                            {{colors.find(c => c.color.includes(item.color)).name}}
                                        </v-chip>
                                    </td>
                                    <td>{{item.gates.filter(g => g.direction == 0 || g.direction == 2).length == 0? '-' : item.gates.filter(g => g.direction == 0 || g.direction == 2).map(g => g.name).reduce((accumulator, current) => accumulator + ", " + current)}}</td>
                                    <td>{{item.gates.filter(g => g.direction == 1 || g.direction == 2).length == 0? '-' : item.gates.filter(g => g.direction == 1 || g.direction == 2).map(g => g.name).reduce((accumulator, current) => accumulator + ", " + current)}}</td>
                                    <td>{{item.disable ? 'deaktivert' : 'aktivert'}}</td>
                                    <td>{{item.multiBook ? "ja":"nei"}}</td>
                                    <td>
                                        <v-row justify="center">
                                            <v-col cols="6">
                                                <v-icon @click.stop="openEditZone(item)" color="info">mdi-pencil</v-icon>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-icon @click.stop="requestDelete(item)" color="info">mdi-delete</v-icon>
                                            </v-col>
                                        </v-row>

                                        <v-dialog v-model="deleteShow" :width="$vuetify.breakpoint.lgAndUp ? '50%' : '100%'">
                                            <v-card>
                                                <v-card-title class="headline grey lighten-2">
                                                    Slett sone?
                                                </v-card-title>
                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn @click="cancelDelete">Avbryt</v-btn>
                                                    <v-btn @click="confirmDelete" color="success">OK</v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-col>

                    <v-col cols="12" lg="4">
                        <h2>Riggplan</h2>
                        <!-- <span v-if="!siteplan.loading && !siteplan_api" class="ma-2">
                    <v-icon>mdi-alert</v-icon> Ingen riggplan lasted opp
                </span>
                <v-progress-linear v-if="siteplan.loading" indeterminate color="primary"></v-progress-linear>
                <v-img top contain :src="siteplan_api" @click="siteplan.showSiteplan = true" style="cursor:pointer;" class="ma-1"></v-img> -->

                        <v-carousel>
                            <v-carousel-item v-for="siteplan in siteplans" :key="siteplan" @click="() => { content = siteplan; contentShow = true;}">
                                <v-progress-linear v-if="!siteplan.src" indeterminate></v-progress-linear>
                                <v-img v-if="/^data:image\/.*/.test(siteplan.src) && !!siteplan.src" :src="siteplan.src" contain height="100%" width="100%"></v-img>

                                <iframe v-if="/^data:application\/pdf.*/.test(siteplan.src) && !!siteplan.src" :src="`${siteplan.url}#view=Fit&toolbar=0`" allowfullscreen="false" style="height: -webkit-fill-available; width: -webkit-fill-available; padding: 0px; margin: 0px; border: none;"></iframe>
                            </v-carousel-item>
                        </v-carousel>
                    </v-col>
                </v-row>
            </v-col>

        </v-row>

        <v-dialog v-model="contentShow" @keydown.esc="() => {contentShow = false; contentFullscreen = false;}">
            <div v-if="content && content.name" style="max-height: 90vmin; background: white; position: relative;">
                <div style="position: absolute; background: rgba(255,255,255,0.65); z-index: 10;" class="ma-2 pa-2 text-h6">{{/.*\/.*\/(.*)/.exec(content.name)[1]}}</div>
                <div style="position: absolute; top: 10px; right: 10px; z-index: 10; display: flex; flex-direcion: row;">
                    <v-btn fab small color="rgba(255,255,255,0.65)" style="position: sticky;" @click="() => {contentFullscreen = !contentFullscreen;}">
                        <v-icon v-if="contentFullscreen">mdi-fullscreen-exit</v-icon>
                        <v-icon v-else>mdi-fullscreen</v-icon>
                    </v-btn>
                    <div class="mx-1"></div>
                    <v-btn fab small color="rgba(255,255,255,0.65)" style="position: sticky;" @click="() => { contentShow = false; contentFullscreen = false;}">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>

                <v-img v-if="!contentFullscreen" :src="content.src" class="ma-auto" max-height="90vmin" max-width="90vmin" :contain="!contentFullscreen"></v-img>
                <v-img v-else :src="content.src" class="ma-auto"></v-img>

            </div>
        </v-dialog>

        <v-dialog :disabled="this.$store.getters.rights > 0" v-model="showNewZoneDialog" width="500px">
            <v-card>
                <v-card-title>
                    <span class="headline">Ny sone</span>
                </v-card-title>
                <v-card-text>
                    <v-form v-model="zoneFormValid">
                        <v-text-field label="Navn" v-model="zoneName" :rules="[v => !!v || 'Påkrevd']"></v-text-field>
                        <v-select label="Farge" :items="colors" v-model="zoneColor" :rules="[v => !!v.name || 'Påkrevd']" return-object dense>
                            <template slot="selection" slot-scope="data">
                                <v-chip>
                                    <v-avatar size="16" :color="data.item.color"></v-avatar>
                                    {{data.item.name}}
                                </v-chip>
                            </template>
                            <template slot="item" slot-scope="data">
                                <v-chip>
                                    <v-avatar size="16" :color="data.item.color"></v-avatar>
                                    {{data.item.name}}
                                </v-chip>
                            </template>
                        </v-select>
                        <!-- <v-select label="Inngangsporter" :items="gates.filter(g => g.direction == 0 || g.direction == 2)" v-model="gates" :rules="[v => v.length >0 || 'Påkrevd']" item-text="name" return-object multiple></v-select> -->
                        <!-- <v-select label="Utgangsporter" :items="gates.filter(g => g.direction == 1 || g.direction == 2)" v-model="gates" :rules="[v => v.length >0 || 'Påkrevd']" item-text="name" return-object multiple></v-select> -->
                        <v-select v-model="selectedGates" :items="gates" item-value="id" :item-text="testMethod" label="Porter" :rules="[v => !!v && v.length > 0 || 'Påkrevd']" multiple return-object>
                        </v-select>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="cancelZone">Avbryt</v-btn>
                    <v-btn :disabled="!zoneFormValid" @click="saveZone" color="success">Lagre</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="editZone.show" :disabled="this.$store.getters.rights > 0" width="500px">
            <v-card>
                <v-card-title class="grey lighten-2 headline">
                    {{editZone.zone.name}}
                </v-card-title>
                <v-card-text>
                    <v-form v-model="editZone.valid">
                        <v-text-field v-model="editZone.zone.name" label="Navn*" :rules="[v => !!v || 'Påkrevd']"></v-text-field>
                        <v-checkbox v-model="editZone.zone.disable" label="Deaktiver denne sone"></v-checkbox>
                        <v-checkbox v-model="editZone.zone.multiBook" label="Kan multi-booke"></v-checkbox>
                        <v-select v-model="editZone.zone.color" :items="colors" label="Farge*" return-object>
                            <v-chip slot="item" slot-scope="data">
                                <v-avatar size="16" :color="data.item.color"></v-avatar>
                                {{data.item.name}}
                            </v-chip>
                            <v-chip slot="selection" slot-scope="data">
                                <v-avatar size="16" :color="data.item.color"></v-avatar>
                                {{data.item.name}}
                            </v-chip>
                        </v-select>
                        <v-select v-model="editZone.zone.gates" :items="gates" item-value="id" :item-text="testMethod" label="Porter" :rules="[v => !!v && v.length > 0 || 'Påkrevd']" multiple return-object>

                        </v-select>
                        <!-- <v-select v-model="editZone.zone.entryGates" :items="gates.filter(g => g.direction == 0 || g.direction == 2)" item-value="id" item-text="name" label="Inngangsporter" :rules="[v => v.length > 0 || 'Påkrevd']" multiple return-object></v-select>
                        <v-select v-model="editZone.zone.exitGates" :items="gates.filter(g => g.direction == 1 || g.direction == 2)" item-value="id" item-text="name" label="Utgangsporter" :rules="[v => v.length > 0 || 'Påkrevd']" multiple return-object></v-select> -->
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="closeEditZone">avbryt</v-btn>
                    <v-btn @click="saveEditZone" color="primary">ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
// import axios from "axios";

export default {
    data() {
        return {
            zones: [],
            zonesLoading: false,
            zoneHeaders: [
                { text: "Navn", value: "name" },
                { text: "Farge", value: "color" },
                { text: "Inngangsporter", sortable: false },
                { text: "Utgangsporter", sortable: false },
                { text: "Deaktivert", sortable: false },
                { text: "Multi-booke", sortable: false },
                { text: "Handlinger", sortable: false },
            ],
            model: "",
            files: {},
            counter: 5,

            showNewZoneDialog: false,
            editZone: {
                show: false,
                valid: true,
                zone: {
                    id: 0,
                    name: "",
                    color: "",
                    gates: [],
                },
            },

            deleteShow: false,
            deleteZone: null,

            gates: [],
            selectedGates: [],
            zoneColor: {},
            zoneName: "",
            zoneId: 0,
            zoneFormValid: true,
            colors: [
                { name: "rød", color: "red lighten-2" },
                { name: "rosa", color: "pink lighten-2" },
                { name: "lilla", color: "purple lighten-2" },
                { name: "indigo", color: "indigo lighten-2" },
                { name: "blå", color: "blue lighten-2" },
                { name: "cyan", color: "cyan lighten-2" },
                { name: "blågrønn", color: "teal lighten-2" },
                { name: "grønn", color: "green lighten-2" },
                { name: "lime", color: "lime lighten-2" },
                { name: "gul", color: "yellow lighten-2" },
                { name: "oransje", color: "orange lighten-2" },
                { name: "brunn", color: "brown lighten-2" },
            ],
            content: { name: undefined },
            contentShow: false,
            contentFullscreen: false,
        };
    },
    computed: {
        siteplans() {
            return this.$store.getters.filesByType("siteplans");
        },
    },
    methods: {
        testMethod: function (item) {
            let direction = "";
            switch (item.direction) {
                case 0:
                    direction = "INN";
                    break;
                case 1:
                    direction = "UT";
                    break;
                case 2:
                    direction = "TOVEIS";
                    break;
            }
            return `${item.name} (${direction})`;
        },
        openEditZone: function (zone) {
            Object.assign(this.editZone.zone, zone);

            // this.editZone.zone.gates = [];
            // this.editZone.zone.gates.filter(g => g.direction == 0 || g.direction == 2)
            //     .concat(this.editZone.zone.gates)
            //     .forEach(gate => {
            //         if (!this.editZone.zone.gates.find(g => g.id === gate.id))
            //             this.editZone.zone.gates.push(gate);
            //     });

            this.editZone.zone.color = this.colors.find((c) => c.color.includes(this.editZone.zone.color));

            this.editZone.show = true;
        },
        closeEditZone: function () {
            this.editZone.zone = {
                id: 0,
                name: "",
                disable: false,
                multiBook: false,
                color: "",
                gates: [],
            };
            this.editZone.show = false;
        },
        saveEditZone: function () {
            var zone = {
                id: this.editZone.zone.id,
                name: this.editZone.zone.name,
                disable: this.editZone.zone.disable,
                multiBook: this.editZone.zone.multiBook,
                color: this.editZone.zone.color.color.split(" ")[0],
                gates: this.editZone.zone.gates.map((g) => {
                    return {
                        "#dbRef": g.id,
                    };
                }),
            };

            this.axios
                .post(`/zone/${zone.id}?includes=gates`, zone)
                .then((response) => {
                    if (response.data.success) {
                        return response.data.data;
                    }

                    throw new Error("create zone failed");
                })
                .then((zone) => {
                    this.closeEditZone();
                    let index = this.zones.findIndex((z) => z.id === zone.id);
                    if (index >= 0) {
                        this.zones.splice(index, 1, zone);
                    }
                })
                .catch(() => {
                    // console.log(err);
                });
        },
        requestDelete: function (zone) {
            this.deleteZone = zone;
            this.deleteShow = true;
        },
        cancelDelete: function () {
            this.deleteShow = false;
            this.deleteZone = null;
        },
        confirmDelete: function () {
            this.axios
                .delete(`/zone/${this.deleteZone.id}`)
                .then((response) => {
                    if (response.data.success) {
                        let index = this.zones.findIndex((z) => z.id === this.deleteZone.id);
                        if (index >= 0) {
                            this.zones.splice(index, 1);
                        }
                        this.$store.commit("snackbar", {
                            text: `${this.deleteZone.name} slettet.`,
                            color: "success",
                            show: true,
                        });
                    } else {
                        this.$store.commit("snackbar", {
                            text: `${this.deleteZone.name} ikke slettet.`,
                            color: "error",
                            show: true,
                        });
                    }
                })
                .catch(() => {
                    this.$store.commit("snackbar", {
                        text: `${this.deleteZone.name} ikke slettet.`,
                        color: "error",
                        show: true,
                    });
                })
                .finally(() => {
                    this.deleteShow = false;
                    this.deleteZone = null;
                });
        },

        saveZone: function () {
            var zone = {
                name: this.zoneName,
                color: this.zoneColor.color,
                // entryGates: this.entryGates.map(g => {
                //     return { "#dbRef": g.id };
                // }),
                // exitGates: this.exitGates.map(g => {
                //     return { "#dbRef": g.id };
                // }),
                gates: this.selectedGates.map((g) => {
                    return {
                        "#dbRef": g.id,
                    };
                }),
            };

            this.axios
                .put(`/zone`, zone)
                .then((response) => {
                    if (response.data.success) {
                        return response.data.data;
                    }

                    throw new Error("create zone failed");
                })
                .then(() => {
                    // console.log(zone);
                    this.showNewZoneDialog = false;
                    this.entryGates = [];
                    this.exitGates = [];
                    this.zoneColor = {};
                    this.zoneName = "";
                    this.zoneFormValid = true;

                    var params = {};
                    Object.assign(params, this.axios.defaults.params);

                    params.includes = "gates";

                    // reload zones
                    this.axios
                        .get("/zone", {
                            params: params,
                        })
                        .then((response) => {
                            if (response.data.success) this.zones = response.data.data;
                        })
                        .catch(() => {
                            // console.log(err);
                        });
                })
                .catch(() => {
                    // console.log(err);
                });
        },
        cancelZone: function () {
            this.showNewZoneDialog = false;
            this.entryGates = [];
            this.exitGates = [];
            this.zoneColor = {};
            this.zoneName = "";
            this.zoneFormValid = true;
        },
        async listSiteplans() {
            let files = await this.$store.dispatch("listFiles", "siteplans");
            files.forEach(async (file) => {
                await this.$store.dispatch("addFile", file);
                if (!this.$store.getters.file(file.name).src) {
                    let { binary, buffer, src, blob, url } = await this.$store.dispatch("downloadFile", file.name);

                    this.$set(file, "binary", binary);
                    this.$set(file, "buffer", buffer);
                    this.$set(file, "src", src);
                    this.$set(file, "blob", blob);
                    this.$set(file, "url", url);
                    await this.$store.dispatch("addFile", file);
                }
            });
        },
    },
    mounted() {
        this.zonesLoading = true;

        var params = {};
        Object.assign(params, this.axios.defaults.params);

        params.includes = "gates";

        this.axios
            .get("/zone", {
                params: params,
            })
            .then((response) => {
                if (response.data.success) {
                    let zones = response.data.data;
                    // zones.forEach(zone => {
                    //     zone.gates = [];
                    //     zone.entryGates.concat(zone.exitGates).forEach(gate => {
                    //         if (!zone.gates.find(g => g.id === gate.id))
                    //             zone.gates.push(gate);
                    //     });
                    // });
                    this.zones = zones;
                }
            })
            .catch(() => {
                // console.log(err);
            })
            .finally(() => {
                this.zonesLoading = false;
            });

        this.axios.get("/gate").then((response) => {
            if (response.data.success) {
                // response.data.data.forEach(g => {
                //     delete g.zones;
                // });
                this.gates = response.data.data;
                return;
            }

            throw new Error(response.data.message);
        });

        this.listSiteplans();
    },
    beforeRouteEnter(to, from, next) {
        next((vue) => {
            vue.$store.commit("showAppBar", true);
            vue.$store.commit("showNavDrawer", true);
        });
    },
};
</script>

<style lang="scss" scoped>
</style>
